module.exports = __webpack_public_path__ + "fonts/fa-brands-400.fa749ec7.ttf";